module.exports = __webpack_public_path__ + "img/error-submit-1.d556a62.webp";